import styled from "@emotion/styled";
import { RichTextStyle } from "../rules";
var getTextStyleRules = function(rules) {
    var hasSpacedParagraphs = typeof (rules === null || rules === void 0 ? void 0 : rules.hasSpacedParagraphs) === "undefined" ? true : rules.hasSpacedParagraphs;
    var style = typeof (rules === null || rules === void 0 ? void 0 : rules.style) === "undefined" ? RichTextStyle.Primary : rules.style;
    return {
        hasSpacedParagraphs: hasSpacedParagraphs,
        style: style
    };
};
var setColor = function(rules) {
    var style = getTextStyleRules(rules).style;
    return style === RichTextStyle.Muted ? "grey" : "";
};
var setTextColor = function(rules) {
    var style = getTextStyleRules(rules).style;
    return style === RichTextStyle.Alternative ? "white" : "";
};
var setMarginTop = function(rules) {
    var hasSpacedParagraphs = getTextStyleRules(rules).hasSpacedParagraphs;
    return hasSpacedParagraphs ? "1.5rem" : "";
};
var ContentfulRichTextWrapper = /*#__PURE__*/ styled("article", {
    target: "e753wxq0"
})("font-size:1.063rem;font-weight:400;line-height:1.588em;& > p:not(:first-of-type){margin-top:", function(p) {
    return setMarginTop(p.textStyle);
}, ";}& > p,& > p > a,& > ol > li,& > ul > li{color:", function(p) {
    return setTextColor(p.textStyle);
}, ";}color:", function(p) {
    return setColor(p.textStyle);
}, ";a{color:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";}ul{list-style-type:disc;padding-left:1.25rem;}ol{list-style-type:decimal;padding-left:1.25rem;}p{white-space:pre-wrap;}& > p + h2{margin-top:3rem;}& > table{width:100%;border:none;margin:1rem 0 3rem;padding:0;font-size:1rem;line-height:1.5rem;td{padding:0.625rem;border:none;}th{margin:0.375rem;padding:0.375rem;text-align:left;}tbody > tr:first-of-type td,tr th{background-color:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";}thead + tbody > tr:first-of-type td{background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural10;
}, ";color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";}tr:nth-of-type(odd),tr:nth-of-type(odd) td{background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural10;
}, ";}tr:nth-of-type(even),tr:nth-of-type(even) td{background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";}}");
var BoldWrapper = /*#__PURE__*/ styled("strong", {
    target: "e753wxq1"
})("font-weight:bold;");
var ItalicWrapper = /*#__PURE__*/ styled("i", {
    target: "e753wxq2"
})("font-style:italic;");
var UnderlineWrapper = /*#__PURE__*/ styled("span", {
    target: "e753wxq3"
})("text-decoration:underline;");
export { BoldWrapper, ItalicWrapper, ContentfulRichTextWrapper, UnderlineWrapper };
